import styled from 'styled-components';

const DivThreadInput = styled.div`
  margin-top: 32px;
`;

export default DivThreadInput;
